import WithGradient from 'components/UI/Landing/with-gradient'
import CalculatorView from 'components/views/Landing/calculator-view'
import Contacts from 'components/views/Landing/contacts.view'
import FooterBottom from 'components/views/Landing/footer-bottom.view'
import FooterDesktop from 'components/views/Landing/footer-desktop.view'
import FaqSection from 'components/views/Landing/section-faq.view'
import MainSection from 'components/views/Landing/section-main.view'
import ProsSection from 'components/views/Landing/section-pros.view'
import StepsSection from 'components/views/Landing/section-steps.view'
import TermsSection from 'components/views/Landing/section-terms.view'
import Statistics from 'components/views/Landing/statistics.view'
import { useAppDispatch } from 'hooks'
import { useSearchParams } from 'react-router-dom'
import { Element } from 'react-scroll'
import { setUtmParams } from 'redux/store/slices/loanSlice'

const IndexPage = () => {
  const dispatch = useAppDispatch()

  const [searchParams] = useSearchParams()

  if (searchParams.get('click_code')) {
    dispatch(
      setUtmParams({
        utm_click_id: searchParams.get('click_code'),
        utm_source: searchParams.get('utm_source'),
        utm_medium: searchParams.get('utm_medium'),
        utm_campaign: searchParams.get('utm_campaign'),
        utm_content: searchParams.get('utm_content')
      })
    )
  }

  return (
    <div
      style={{
        backgroundColor: 'var(--bg-landing-main)',
        fontFamily: "'Inter', sans-serif"
      }}
    >
      <Element name='main-section'>
        <MainSection />
      </Element>
      <Element name='calculator-section'>
        <CalculatorView />
      </Element>
      <Element name='terms-section'>
        <TermsSection />
      </Element>
      <Element name='steps-section'>
        <StepsSection />
      </Element>
      <Element name='pros-section'>
        <ProsSection />
      </Element>
      <Element name='statistics'>
        <Statistics />
      </Element>
      <Element name='faq-section'>
        <FaqSection />
      </Element>
      <Contacts />
      <FooterDesktop />
      <FooterBottom />
      <WithGradient className='rounded-full w-[700px] h-[700px] absolute top-[650px] -left-[170%] sm:-left-[70%] md:-left-[35%] opacity-60 blur-[115px] ' />
    </div>
  )
}

export default IndexPage
